import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const adminAuthGuard: CanActivateFn = () => {
    const router = inject(Router);

    const token =
        localStorage.getItem('admin_token') ??
        sessionStorage.getItem('admin_token');

    if (!token) {
        router.navigate(['/admin/login']);
        return false;
    }
    return true;
};